import base from './base.repository';
import base2 from './base2.repository';
export default {
    ...base,
    all(filters, page) {
        // this.get(`users/all?name=${filters.name}&document=${filters.document}&profile=${filters.profileId}&client=${filters.clientId}&page=${page}`);
        const params = {...filters, page};
        const queryString = this.querify(params);
        this.get(`users/all${queryString}`);
        return this;
    },
    simple: (payload = {}) => base2.get(`users/simple`, payload),
    getProfiles() {
        this.get('users/profiles/all');
        return this;
    },
    getOperatives() {
        this.get('users/operatives');
        return this;
    },
    saveUser(user) {
        this.post(`users`, user);
        return this;
    },
    updateUser(user, id) {
        this.put('users/' + id, user);
        return this;
    },
    deleteUser(id){
        this.delete('users/'+ id);
        return this;
    },
    resetPassword(id){
        this.post('users/'+id+'/reset-password');
        return this;
    },
    assignationsUser(user, clientId){
        this.get('users/'+user.id+'/clients/'+clientId+'/assignations-user');
        return this;
    },
    assignationToUser(payload){
        this.post('users/assignation-to-user', { userId: payload.userId, structureId: payload.structureId,
            assignedBy: payload.assignedBy, dateValidate: payload.dateValidate });
        return this;
    },
    
    removeAssignation(id){
        this.post('users/'+id+'/remove-assignation');
        return this;
    },
    changePassword(payload){
        this.post('users/change-password-user', {userId: payload.userId, password1: payload.password1, password2: payload.password2, oldPassword: payload.oldPassword});
        return this;
    },
    getPositions(){
        this.get('users/positions/all');
        return this;
    },
    loadUsersByPosition(positionId){
        this.get(`users/by-position?position=${positionId}`);
        return this;
    },
    getAdministrativeUsers() {
        this.get('users/administratives');
        return this;
    },
    getExecutives: () => base2.get('users/executives'),
    activate: (userId) => base2.post('users/activate', { userId }),
    saveAssignations: (payload) => base2.post('users/assignations', payload),
    getBodyGuards: () => base2.get('users/bodyguards'),
    getSupervisors: () => base2.get('users/supervisors'),
    getUserInfo: userId => base2.get(`users/${userId}/info`),
    saveUserInfo: (userId, payload) => base2.post(`users/${userId}/info`, payload),
    saveUserInfo2: (userId, payload) => base2.post(`users/${userId}/info2`, payload),
    getLogs: userId => base2.get(`users/${userId}/logs`),
    getGuards: () => base2.get('users/guards'),
    updatePhoto: (userId, photo) => base2.post(`users/${userId}/photo`, {photo}),
    deletePhoto: userId => base2.delete(`users/${userId}/photo`)
};
